import styled from 'styled-components'
import { Box } from 'src/components'
import { motion } from 'framer-motion'
import Menu from '@mui/material/Menu'

export const ContentImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`
export const ContentImageSection = styled(Box)`
    width: 29.33px;
    height: 20px;
    object-fit: contain;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const ContentSelectMobile = styled(motion(Box))`
    position: relative;
    width: 30px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        display: flex;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        display: none;
    }
`

export const MenuItemContent = styled(Menu)`
    margin-top: 12px;
    margin-left: 14px !important;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        margin-top: 10px;
        margin-left: 0;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        margin-top: 20px;
    }
`
